const storage = localStorage;

export function getItem<T>(key: string): T | null {
  const value = storage.getItem(key);
  return value ? JSON.parse(value) || null : null;
}

export function getString(key: string): string | null {
  return storage.getItem(key);
}

export function setItem<T>(key: string, value: T) {
  storage.setItem(key, JSON.stringify(value));
}

export function removeItem(key: string) {
  storage.removeItem(key);
}
